// App Imports
import banners from './list'

const index = {
  banners
}
export default index;